export enum Color {
    PRIMARY = 'primary',
    ACCENT = 'accent',
    WARN = 'warn',
}
